export default "__VITE_ASSET__D50Q1Mqw__"